module.exports = __webpack_public_path__ + "static/img/news2_22.6c0449a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news2_22.png
// module id = /Ask
// module chunks = 0